import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MANAGE_SUBS_GET_SUBSTITUTIONS_DATA_BEGIN,
  MANAGE_SUBS_GET_SUBSTITUTIONS_DATA_SUCCESS,
  MANAGE_SUBS_GET_SUBSTITUTIONS_DATA_FAILURE,
  MANAGE_SUBS_GET_SUBSTITUTIONS_DATA_DISMISS_ERROR,
} from './constants';
import { API_REQUEST_URL } from '../../../common/apiConfig';

export function getSubstitutionsData(args = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_GET_SUBSTITUTIONS_DATA_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      let conditions = args;
      const doRequest = axios.post(`${API_REQUEST_URL}/getSubstitutionsData`, conditions, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          const data = res.data;
          dispatch({
            type: MANAGE_SUBS_GET_SUBSTITUTIONS_DATA_SUCCESS,
            data: data,
          });
          resolve(data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_GET_SUBSTITUTIONS_DATA_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetSubstitutionsDataError() {
  return {
    type: MANAGE_SUBS_GET_SUBSTITUTIONS_DATA_DISMISS_ERROR,
  };
}

export function useGetSubstitutionsData() {
  const dispatch = useDispatch();

  const { getSubstitutionsDataPending, getSubstitutionsDataError } = useSelector(
    state => ({
      getSubstitutionsDataPending: state.manageSubs.getSubstitutionsDataPending,
      getSubstitutionsDataError: state.manageSubs.getSubstitutionsDataError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(getSubstitutionsData(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissGetSubstitutionsDataError());
  }, [dispatch]);

  return {
    getSubstitutionsData: boundAction,
    getSubstitutionsDataPending,
    getSubstitutionsDataError,
    dismissGetSubstitutionsDataError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_GET_SUBSTITUTIONS_DATA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getSubstitutionsDataPending: true,
        getSubstitutionsDataError: null,
      };

    case MANAGE_SUBS_GET_SUBSTITUTIONS_DATA_SUCCESS:
      // The request is success
      return {
        ...state,
        getSubstitutionsDataPending: false,
        getSubstitutionsDataError: null,
      };

    case MANAGE_SUBS_GET_SUBSTITUTIONS_DATA_FAILURE:
      // The request is failed
      return {
        ...state,
        getSubstitutionsDataPending: false,
        getSubstitutionsDataError: action.data.error,
      };

    case MANAGE_SUBS_GET_SUBSTITUTIONS_DATA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getSubstitutionsDataError: null,
      };

    default:
      return state;
  }
}
